import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { CategoryService } from '@services/category.service';
import { SearchService } from '@services/search.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import { MapsAPILoader } from "@agm/core";
import * as _ from 'lodash';
import { google } from "google-maps";
declare var google: google;
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { TagModel } from 'ngx-chips/core/accessor';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-cevent',
  templateUrl: './cevent.component.html',
  styleUrls: ['./cevent.component.sass']
})
export class CeventComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  autocomplete_load = false;
  params: any = [];
  appCreateForm: FormGroup;
  application = "";
  country = "";
  component = "";
  category = "";
  location_response: any = [];
  pathToMedia: any = {};
  image_paths: any = [];
  privacy_list: any = [];
  country_code = "";
  timezone_list: any = [];
  location_list: any = [];
  country_list: any = [];
  status_list: any = [];
  host_list: any = [];
  error: any = { location: '', startDate: '', endDate: '', countryCode: '', name: '', categoryJson: '', country: '', timeZone: '', 'title': '', 'startTime': '', 'endTime': '', streetAddress: '', city: '', state: '', zip: '', category: '', email: '', description: '', privacy: '' };
  selected_category = "";
  lat = 0;
  location = '';
  btn_process = false;
  lng = 0;
  min = null;
  eic = 0;
  mic = 0;
  invitees: any = [];
  emailinvitees: any = [];
  members_response: any = [];
  map_details: any = { lat: '', lng: '', label: 'L', info: '' };
  constructor(private http: HttpClient, private _viewService: ViewService, private ngZone: NgZone, private MapsAPILoader: MapsAPILoader, private _searchService: SearchService, private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SB;
    this.min = new Date();
    this.application = "event";
    this.appCreateForm = this.fb.group({
      status: [],
      locationId: [],
      url: [],
      streetAddress: [],
      hostName: [],
      city: [],
      state: [],
      hostDescription: [],
      countryCode: [],
      hostId: [this._global.getSessionVal('id')],
      zip: [],
      address: [],
      timeZone: ['IET'],
      title: [],
      startTime: [],
      privacy: [],
      endTime: [],
      email: [],
      paid: [],
      price: [],
      goal: [],
      invitees: [],
      emailinvitees: [],
      description: [],
      requirement: []
    });

    let THIS = this;
    let p = {
      'component': this.component,
      'application': 'category',
      'categoryType': this.application
    };
    this._categoryService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let result = this._global.getVal(data, 'response', '');
          CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.category, this.application, true);
          $("div#" + this.application + "_category").click(function (e) {
            var $target = $(e.target);
            if ($target.attr("id") === "categoryCheck") {
              let result = Helper.getCategoryChecboxValues("categoryCheck", '');
              THIS.selected_category = Helper.categoryJsonText("categoryCheck");
            }
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let f = {
      'component': this.component,
      'application': this.application
    };

    this._formdataService.countries(f).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.country_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'time').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.timezone_list = this._global.getVal(data, 'response.timeZone', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let s = {
      'component': this.component,
      'application': 'location',
      'sortOrder': 'desc',
      'status': 'active',
      'sortString': 'createdTime',
      "start": 0,
      "rows": 100
    };
    this._searchService.application(s).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.location_list = this._global.getVal(data, 'response.docs', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this.hostView();

  }

  @ViewChild('streetAddress', { static: false }) public addressElement: ElementRef;
  ngOnInit() {


  }
  returnZero() {
    return 0
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }
  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
    this.image_paths = [];
    this.image_paths.push(this.pathToMedia);
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');
  }
  public cancel() {
    this.router.navigate(['/my/event']);
  }
 
  save() {
    this.error = { startDate: '', endDate: '', location: '', countryCode: '', name: '', categoryJson: '', country: '', timeZone: '', 'title': '', 'startTime': '', 'endTime': '', streetAddress: '', city: '', state: '', zip: '', category: '', email: '', description: '', privacy: '' };

    /*  invitees: [],
     emailinvitees: [], */
    this.btn_process = true;
    let r = this.appCreateForm.value;
    r.component = this.component;
    r.application = this.application;
    r = this._global.paramsRemoveNull(r);

    if (r.startTime) {
      r.startTime = new Date(r.startTime).getTime();
    }
    if (r.endTime) {
      r.endTime = new Date(r.endTime).getTime();
    }
    let latlongs = {};
    if (this.lat != 0) {
      latlongs['lat'] = this.lat;
    }
    if (this.lng != 0) {
      latlongs['lon'] = this.lng;
    }
    if (!_.isEmpty(latlongs)) {
      r.latlong = JSON.stringify(latlongs);
    }
    r.publish = true;
    r.country = this.country;
    let p = this._global.generateParams(r, ['invitees', 'emailinvitees']);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    let invitees = [];
    Object.entries(this.appCreateForm.value['invitees']).forEach(([key, value]) => {
      invitees.push(value['id']);

    });
    Object.entries(this.appCreateForm.value['emailinvitees']).forEach(([key, value]) => {
      invitees.push(value['value']);
    });
    p['invitees'] = invitees.join(",");
    this._saveService.app(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/my/'+this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  getDialCode(event) {
    let res = this.country_list.find(x => x.value == event);
    this.country = this._global.getVal(res, "name", '');
    this.country_code = this.appCreateForm.value["countryCode"];

  }
  hostView() {
    let l = {
      'component': this.component,
      'application': 'member',
      'id': this._global.getSessionVal('id')
    };
    this._viewService.application(l).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let r = this._global.getVal(data, 'response', '');
          this.appCreateForm.get("hostName").setValue(r['firstName'] + ' ' + r['lastName']);
          this.appCreateForm.get("hostDescription").setValue(r['description']);
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

 /*  getLocation(event) {
    let l = {
      'component': this.component,
      'application': 'location',
      'id': event
    };
    this._viewService.application(l).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.location_response = this._global.getVal(data, 'response', '');
          this.appCreateForm.get("countryCode").setValue(this.location_response.countryCode);
          this.appCreateForm.get("city").setValue(this.location_response.city);
          this.appCreateForm.get("state").setValue(this.location_response.state);
          this.appCreateForm.get("zip").setValue(this.location_response.zip);
          this.appCreateForm.get("address").setValue(this.location_response.address);
          this.appCreateForm.get("streetAddress").setValue(this.location_response.streetAddress);
          this.country_code = this.location_response.countryCode;
          let res = this.country_list.find(x => x.value == this.country_code);
          this.country = this._global.getVal(res, "name", '');
          this.getLatLan(this._global.getVal(this.location_response, 'streetAddress', ''));
          this.map_details['info'] = this._global.getVal(this.location_response, 'streetAddress', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  } */
  getAddress() {
    let THIS = this;
    console.log("his.addressElement.nativeElement", this.addressElement.nativeElement);
    this.MapsAPILoader.load().then(
      () => {
        let automcomplete = new google.maps.places.Autocomplete(this.addressElement.nativeElement, { types: ["address"], componentRestrictions: { country: THIS.country_code } });
        automcomplete.addListener("place_changed", () => {

          let p = this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = automcomplete.getPlace();
            if (place.geometry == undefined || place.geometry == null) {
              //return place;
            } else {


              let address = place.address_components;
              let geometry = place.geometry;
              THIS.appCreateForm.get('streetAddress').setValue(place["formatted_address"]);
              THIS.map_details["info"] = place.name;
              address.forEach(function (value) {
                if (value["types"][0] == 'country') {
                  //  THIS.country_code= value["short_name"];
                  // THIS.appCreateForm.get('country').setValue( THIS.country_code);

                } else if (value["types"][0] == 'locality') {
                  THIS.appCreateForm.get('city').setValue(value["long_name"]);
                } else if (value["types"][0] == 'administrative_area_level_1') {
                  THIS.appCreateForm.get('state').setValue(value["long_name"]);
                } else if (value["types"][0] == 'postal_code') {
                  THIS.appCreateForm.get('zip').setValue(value["long_name"]);
                }
              });
              if (geometry) {
                let lat = geometry.location.lat();
                let lng = geometry.location.lng();
                THIS.lat = lat;
                THIS.lng = lat;
                THIS.map_details["lat"] = lat;
                THIS.map_details["lng"] = lng;

              }
            }
          })
        })
      }
    )
  }
  getStartDate(e){
    const event = new Date(e);
    event.setHours(event.getHours()+3);
    this.appCreateForm.get("endTime").setValue(new Date(event)); 
  }
  getLatLan(address: string) {
    let THIS = this;
    this.MapsAPILoader.load().then(() => {
      console.log('google script loaded');
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          THIS.map_details['lat'] = results[0].geometry.location.lat();
          THIS.map_details['lng'] = results[0].geometry.location.lng();
        } else {

        }
      });
    });
  }
  memberInvitieesCount(e) {
    this.mic = (this.appCreateForm.value['invitees']).length;
  }
  emailInvitieesCount(e) {
    this.eic = (this.appCreateForm.value['emailinvitees']).length;
  }
  public requestAutocompleteItems = (text: string): Observable<any[]> => {
    let r = [];
    let p = {
      'component': this.component,
      'application': 'member',
      firstName: text,
      lastName: text,
      email: text,
      start: 0,
      rows: 10
    };
    return this._searchService.application(p).map(
      data => {
        this.autocomplete_load = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          let result = this._global.getVal(data, 'response.docs', '');
          for (let s in result) {
            r.push({ name: result[s]["email"], email: result[s]["firstName"] + ' ' + result[s]["lastName"] + ' ' + result[s]["email"], id: result[s]["id"] });
          }

        }
        return r;
      });
  }
  public onAdding(tag: TagModel): Observable<TagModel> {
    tag['display'] = tag['name']
    const confirm = true;
    return of(tag).pipe(filter(() => confirm));
  }
}
